export default {"src":"/_next/static/media/AG.a70b585e.svg","height":18,"width":18};